const initialState = {
  logisticsDetail: {},
};

// 物流详情
export default function receiveLogisticsDetailDate(state = initialState, action) {
  switch (action.type) {
  case 'LOGISTICS_DETAIL':
    return { ...state, logisticsDetail: action.payload };
  default:
    return state;
  }
}